import React, { ChangeEvent, useEffect } from 'react';
import { RoleProps } from '../index';
import { Form } from '../../../../components';
import {
  InstructionWrapper,
  TextField,
  ToggleSwitch
} from '../../../../components/fields';
import Heading from '../../../../_global/components/heading/Heading';
import './_styles.scss';
import { publish, useStateReducer } from '../../../../hooks';
import { StateTopicEnum } from '../../../../enums';
import { validateObject } from '../../../../utilities';
import { Regexes, UserPermissions } from '../../../../definitions';
import { Card } from '@mui/material';

export default function CreateItem({
  data: { rolename, permissions, is_active }
}: RoleProps) {
  const [state, setState] = useStateReducer({
    rolename,
    permissions: [],
    is_active: false
  });

  const [displayName, setDisplayName] = React.useState(
    `${rolename ?? ''} ${' | '} ${is_active ? 'Active' : 'Inactive'}
      }
`.trim()
  );

  const errors = validateObject(
    {
      rolename: {
        regex: Regexes.anyContentRegex,
        message: 'Role  Name is required.'
      }
    },
    state
  );

  const isValid = () => {
    if (errors['rolename']) return false;
    return true;
  };

  React.useEffect(() => {
    setDisplayName(
      `${rolename ?? ''} ${' | '} ${is_active ? 'Active' : 'Inactive'}`.trim()
    );
    publish(StateTopicEnum.IsValid, isValid());
    publish(StateTopicEnum.EditItem, state);
    // eslint-disable-next-line
  }, [state.rolename, state.permissions, state.is_active]);

  const handleChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    key: string
  ) => {
    let value: string | boolean = event.currentTarget.value;
    // @ts-ignore
    if (event.target.type === 'checkbox') value = event.target.checked;
    setState({ [key]: value });
  };

  const handlePermission = (
    checked: boolean,
    value: string,
    viewValue: string | null = null
  ) => {
    let selectedArray: string[] = [...state.permissions];

    if (checked) {
      if (!selectedArray.includes(value)) selectedArray.push(value);
      if (viewValue != null && !selectedArray.includes(viewValue))
        selectedArray.push(viewValue);
    } else {
      selectedArray = selectedArray.filter((item) => item !== value);
    }
    setState({ permissions: selectedArray });
  };

  return (
    <div id='role-create-item'>
      <Heading name={displayName} />
      <Form title='User Role Details'>
        <InstructionWrapper
          text='Enter User Role name here.'
          error={errors['rolename']}
          row
        >
          <TextField
            label='Role Name'
            value={state.first_name}
            onChange={(event) => handleChange(event, 'rolename')}
            error={!!errors['rolename']}
          />
          <ToggleSwitch
            label='Is active'
            name='is_active'
            value={state.is_active}
            onChange={(event) => handleChange(event, 'is_active')}
            className='half-width'
          />
        </InstructionWrapper>
      </Form>

      <Form title={'Permissions'}>
        <InstructionWrapper text='Permissions'>
          <div className='flex-row'>
            <div className='label-col'>
              <TextField value={' '} readOnly />
            </div>
            <div className='switch-col'>
              <TextField value={'View'} readOnly />
            </div>
            <div className='switch-col'>
              <TextField value={'Edit'} readOnly />
            </div>
          </div>
        </InstructionWrapper>

        {UserPermissions.userPermissions.map((userPermission, i) => {
          return (
            <div key={'permissions_card_' + i}>
              <InstructionWrapper
                row
                text={userPermission.label + ' Permissions'}
              >
                <Card className='program-card-edit page-padding'>
                  {[
                    userPermission,
                    ...(userPermission.nested_permissions
                      ? userPermission.nested_permissions
                      : [])
                  ].map((permission, index) => {
                    return (
                      <div
                        key={userPermission.label + index}
                        className='flex-row'
                      >
                        <div className='label-col'>
                          <TextField
                            className={index > 0 ? 'nested-label' : ''}
                            value={permission.label}
                            readOnly
                          ></TextField>
                        </div>

                        <div className='switch-col'>
                          {permission.view ? (
                            <ToggleSwitch
                              label=''
                              name={permission.view}
                              value={
                                state.permissions?.includes(permission.edit)
                                  ? true
                                  : state.permissions?.includes(permission.view)
                              }
                              onChange={(event) =>
                                handlePermission(
                                  event.target.checked,
                                  permission.view,
                                  null
                                )
                              }
                              readOnly={state.permissions?.includes(
                                permission.edit
                              )}
                            />
                          ) : (
                            <ToggleSwitch
                              label=''
                              className='switch-hide'
                              name={permission.view}
                              value={false}
                              readOnly={true}
                            />
                          )}
                        </div>
                        <div className='switch-col'>
                          {permission.edit ? (
                            <ToggleSwitch
                              label=''
                              name={permission.edit}
                              value={state.permissions?.includes(
                                permission.edit
                              )}
                              onChange={(e) =>
                                handlePermission(
                                  e.target.checked,
                                  permission.edit,
                                  permission.view ? permission.view : null
                                )
                              }
                            />
                          ) : (
                            <ToggleSwitch
                              label=''
                              className='switch-hide'
                              name={permission.edit}
                              value={false}
                              readOnly={true}
                            />
                          )}
                        </div>
                      </div>
                    );
                  })}
                </Card>
              </InstructionWrapper>
            </div>
          );
        })}
      </Form>
    </div>
  );
}
